<template>
  <div class="Inside_line_detail" :style="screenHeight">
    <div class="fixed_search" style="height: 100px;">
      <div class="fixed_search_input">
        <Input v-model="callerNum" placeholder="请输入主叫号码" title="主叫号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="calleeNum" placeholder="请输入被叫号码" title="被叫号码"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="pstnNumber" placeholder="请选择热线号码" title="热线号码"/>
      </div>
      <div class="fixed_search_input">
        <Select v-model="dialogType" placeholder="请选择呼叫类型" clearable title="呼叫类型">
          <Option v-for="(option, index) in callTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="fixed_search_input">
        <Select v-model="callState" placeholder="请选择通话状态" clearable title="通话状态">
          <Option v-for="(option, index) in callSateList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareCallTime"  clearable title="通话时长">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="searchCallTime" placeholder="通话时长(秒)" title="通话时长(秒)"/>
      </div>
      <div class="fixed_operation_btn" style="width: 15%">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" style="margin-left: 10px" @click="exportExcel('8_2-1-1','统计报表=>办公话单=>导出')" v-if="roleList['8_2-6-1']">导出</Button>
      </div>
    </div>
    <div class="fixed_table">
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" stripe ref="selection"  @sort-change="sortChange" @selection-change="getSelectedId"  @cell-click="openCallOffice" :cell-class-name="returnClassName">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" sortable="custom" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
        <el-table-column  fixed="right" label="操作" width="150" align="center" v-if="roleList['8_2-6-2'] || roleList['8_2-6-3']">
          <template slot-scope="scope">
            <el-button :disabled="!scope.row.recordFile" @click="playCallRecord(scope.row.recordFile)" type="text" size="small" v-show="roleList['8_2-6-2']">播放</el-button>
            <el-button disabled v-if="!scope.row.recordFile" style="margin-left: 0px;" type="text" size="small" v-show="roleList['8_2-6-3']">下载</el-button>
            <a :href="baseURL+'common/downloadFile.json?type=0&addr='+scope.row.recordFile" target="_blank" v-else class="down_file_a" v-show="roleList['8_2-6-3']">下载</a>
          </template>
        </el-table-column>
      </el-table>
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <publicPop @closePublicPop="closePublicPop" :showPublicPop="showPublicPop" :popSign="popSign"></publicPop>
    <playMusicPop  @closeRecordfile="closeRecordfile" :showRecordFile="showRecordFile" :recordFile="recordFile"></playMusicPop>
    <a :href="musicUrl" id="downFileMusic" style="display: none" target="_blank">下载</a>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
  import publicPop from '@/components/customerMange/PublicPop.vue'
  import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
  export default {
    name: "OfficeCall",
    mixins:[publicFunClass,customerPublicBtn],
    components:{
      publicPop,
      playMusicPop
    },
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        roleList:JSON.parse(localStorage.getItem("roleList")),
        screenHeight:{height:''},
        tableHeight:600,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        pageSize:20,
        speedChangePage: 1,
        musicUrl:'',
        spinShow:false,
        showRecordFile:false,
        recordFile:'',
        editable:false,
        showPublicPop:false,
        checkedAll:false,
        pstnNumber:'',
        pstnNumberList:[],
        dialogType:'',
        callTypeList:[{'id':'S','name':'共振'},{'id':'Q','name':'顺振/轮循'},{'id':'T','name':'呼转'},{'id':'C','name':'会议'}],
        fieldList: [
          {type: 'selection', width: 50},{width: 150,key:'caller','title':'主叫号码'},
          {width: 150,key:'callee','title':'被叫号码'},{key:'pstnNumber','title':'热线号码'},
          {key:'dialogType','title':'呼叫类型'},{width: 100,key:'callState','title':'通话状态'},{width: 200,key:'startTime','title':'开始时间'},{width: 200,key:'duration','title':'通话时长(秒)'}, {key:'minutes4','title':'分钟数'}
        ],
        contentList: [],
        checkIds:[],
        starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
        popSign:'办公话单导出',
        callerNum:'',
        calleeNum:'',
        journalType:"null",
        menuId:"null",
        orderField:'',
        orderRule:'',
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
        callState:'',
        callSateList:[{'id':'已接通','name':'已接通'},{'id':'未接通','name':'未接通'}],
        compareCallTime:'',
        compareList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
        searchCallTime:'',
        queryParam: null,
      }
    },
    methods:{
      openCallOffice:function(row, column){
        if(column.property){
          if(column.property.indexOf('caller')!=-1 && row.callType.indexOf('呼入')!=-1){
            this.messageOrPhone(row.caller);
          }
          if(column.property.indexOf('callee')!=-1 && row.callType.indexOf('呼出')!=-1){
            this.messageOrPhone(row.callee);
          }
        }
      },
      getCustomName:function (name) {
        if(name=="caller" || name=="callerHide"){
          return "calling_number";
        }
        if(name=="callee" || name=="calleeHide"){
          return "origin_callee";
        }
        if(name=="pstnNumber"){
          return "dnis";
        }
        if(name=="dialogType"){
          return "dialog_type";
        }
        if(name=="duration"){
          return "duration";
        }
        if(name=="minutes4"){
          return "duration";
        }
        return name;
      },
      sortChange:function(event){
        if(event && event.order){
          this.orderField=this.getCustomName(event.prop);
          this.orderRule=event.order=="descending"?"desc":"asc";
        }else{
          this.orderField="";
          this.orderRule="";
        }
        this.initSearch();
      },
      initSearch:function () {
        this.spinShow=true;
        this.$emit("closeVn",true);
        let that=this;
        let param={
          orderField:this.orderField,
          orderRule:this.orderRule,
          pageNum:this.currentPage,
          pageSize:this.pageSize,
          starEndTime:this.starEndTime.length==0?"":this.starEndTime.toString(),
          callerNum:this.callerNum,
          calleeNum:this.calleeNum,
          dialogType:this.dialogType,
          pstnNumber:this.pstnNumber,
          callState: this.callState,
          searchCallTime: this.searchCallTime,
          compareCallTime:this.compareCallTime,
          journalType:"统计报表=>明细报表=>办公话单",
          menuId:"null"
        };
        this.queryParam = param;
        this.$http.post("callrecords/callCdr.json",param) .then(function (res) {
          let result=res.data;
          that.spinShow=false;
          if(result.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.checkIds=[];
          that.contentList=res.data.obj.content;
          that.total=res.data.obj.totalSize;
          let timeShowStyle=that.configInfo.timeShowStyle;
          let phoneIsHide= that.configInfo.phoneIsHide;
          for(let i=0;i< that.contentList.length;i++){
            that.contentList[i].callType=that.contentList[i].dialogType;
            if(timeShowStyle=='0'){
              that.contentList[i].callTime=that.contentList[i].durationSecond;
            }
            if(phoneIsHide=='1'){
              that.changeHidePhone(that.fieldList);
            }
          }
        })
      },
      reset:function(){
        this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
        this.callerNum="";
        this.calleeNum="";
        this.pstnNumber="";
        this.dialogType="";
        this.callState = "";
        this.searchCallTime = "";
        this.compareCallTime = "";
      },
      closePublicPop:function (flag,operateStyle,popSign) {
        this.showPublicPop=false;
        let param={
          ids:this.checkIds.toString(),
          journalType:this.journalType+"按选中结果"+popSign,
          menuId:this.menuId,
          type:operateStyle
        };
        if(flag){
          if (operateStyle=='0'){//选中结果
            if (this.checkIds.length==0){
              this.$Modal.info({
                title:'提示',
                content:"请选择要导出的数据"
              });
              return false;
            }
          }
          if (operateStyle=='1'){//按搜索结果
            if(this.contentList.length==0){
              this.$Modal.info({
                title:'提示',
                content:"当前没有可导出的数据"
              });
              return false;
            }
            if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再导出"
                  });
                  return false;
                }
                delete this.queryParam["pageNum"];
                delete this.queryParam["pageSize"];

                this.$set(this.queryParam, 'type', operateStyle);
                this.$set(this.queryParam, 'journalType', this.journalType+"按搜索结果"+popSign);
                this.$set(this.queryParam, 'menuId', this.menuId);
                param = this.queryParam;
          }
          this.$Loading.start();
          this.operateExcelExport(param,"callrecords/exportUaCdrs.json");
        }
      },
      //导出
      exportExcel:function (menuId,journalType) {
        this.journalType=journalType;
        this.menuId=menuId;
        this.showPublicPop=true;
      },
      downCallRecord:function(recordFile){
        if(!recordFile){
          this.$Modal.info({
            title:'提示',
            content:"录音文件不存在"
          });
          return false;
        }
        this.musicUrl=this.baseURL+"common/downloadFile.json?type=0&addr="+recordFile;
        setTimeout(function () {
          document.getElementById("downFileMusic").click();
        },1000);
      },
      playCallRecord:function (recordFile) {
        if(!recordFile){
          this.$Modal.info({
            title:'提示',
            content:"录音文件不存在"
          });
          return false;
        }
        this.showRecordFile=true;
        this.recordFile=this.baseImgURL+recordFile;
      },
      closeRecordfile:function(){
        this.showRecordFile=false;
      }
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight=clientHeight-232;
    },
    destroyed(){
      this.$emit("closeVn",true);
    },
    watch:{
      pageCode:function () {
        if(this.pageCode=='8_2-6' && this.showPageCount==0){
          this.$emit("openVn", true);
          this.getPstnNumber("0");
          this.showPageCount++;
        }
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/detailedReportForm/OfficeCall.vue